/* eslint-disable max-len */

import { useState } from 'react';

import { postPopupsAck } from '@/services/Popups/request';

import { PopupsProps } from '@/context/CustomPopupsContext/types';
import { useToast } from '@/context/ToastContext';

import { useCustomPopups } from '@/hooks/useCustomPopups/useCustomPopups';

import Checkbox from '@/components/CustomPopups/components/Checkbox';
import CloseButton from '@/components/CustomPopups/components/CloseButton';
import FormButton from '@/components/FormButton';

import {
  Body,
  ButtonContainer,
  Container,
  Content,
  Footer,
  Header,
  Text,
  TextBold,
  Title,
} from './styles';

interface IPopupTemplate1 {
  id: number;
  headline: string;
  content: HTMLElement | string;
  confirmButtonText: string;
  consentRequired: boolean;
  consentText: HTMLElement | string;
  consentDescription: HTMLElement | string;
}

const PopupTemplate1 = ({
  id,
  headline,
  content,
  confirmButtonText,
  consentRequired,
  consentText,
  consentDescription,
}: IPopupTemplate1) => {
  const { setPopupsList } = useCustomPopups();
  const toast = useToast();

  const [checked, setChecked] = useState<boolean>(false);

  const handleClosePopup = () => {
    setPopupsList((state: PopupsProps[]) =>
      state.map((item) => ({
        ...item,
        popup_is_open: item.id === id ? false : item.popup_is_open,
      })),
    );
  };

  const handlePopupConfirmation = async () => {
    try {
      await postPopupsAck(id);
      toast.success('Confirmação realizada com sucesso!');
      handleClosePopup();
    } catch {
      toast.error('Não foi possível realizar a confirmação!');
    }
  };

  const contentHTML = content instanceof HTMLElement ? content.outerHTML : content;
  const consentTextHTML = consentText instanceof HTMLElement ? consentText.outerHTML : consentText;
  const consentDescriptionHTML =
    consentDescription instanceof HTMLElement ? consentDescription.outerHTML : consentDescription;

  return (
    <Container key={id}>
      <Header>
        <Title>{headline}</Title>
        {![636, 1370].includes(id) && <CloseButton onClose={() => handleClosePopup()} />}
      </Header>
      <Body>
        <Content>
          <Text dangerouslySetInnerHTML={{ __html: contentHTML }} />
        </Content>
      </Body>
      <Footer>
        {consentRequired && (
          <>
            <TextBold dangerouslySetInnerHTML={{ __html: consentDescriptionHTML }} />
            <Checkbox
              label={consentTextHTML}
              checked={checked}
              setChecked={() => setChecked(!checked)}
            />
          </>
        )}

        <ButtonContainer>
          {consentRequired ? (
            <FormButton
              type="button"
              disable={!checked}
              customColor={checked ? 'blue' : 'blue-light'}
              onClick={checked ? () => handlePopupConfirmation() : () => {}}
            >
              {confirmButtonText}
            </FormButton>
          ) : (
            <FormButton type="button" customColor="blue" onClick={() => handlePopupConfirmation()}>
              {confirmButtonText}
            </FormButton>
          )}
        </ButtonContainer>
      </Footer>
    </Container>
  );
};

export default PopupTemplate1;
